
<template>
  <swiper
    class="clickable"
    :modules="modules"
    :slides-per-view="2"
    :space-between="20"
    :loop="true"
    :breakpoints = breakpoints
    :navigation = "{ nextEl:'.businesslist__controll'}"
    :pagination="{ clickable: true }"
    :scrollbar="{ draggable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="(item, index) in list" :key="index">
      <a :href="item.link" target="_blank" rel="nofollow">
        <figure>
          <img :src="item.pic" :alt="item.dt">
        </figure>
        <dl>
          <dt v-html="item.dt"></dt>
          <dd v-html="item.dd"></dd>
        </dl>
      </a>
    </swiper-slide>
  </swiper>
</template>

<style lang="scss" scoped>
.swiper-slide{
  figure{
    position: relative;
    border-radius: 1rem;
    border: rgba(module.$white,.12) 1px solid;
    overflow: hidden;
    transition: border 320ms module.$ease;
    &:before,
    &:after{
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: module.$black;
      opacity: 0;
      transition: all 320ms module.$ease;
      z-index: 2;
    }
    &:after{
      content: 'MORE';
      width: auto;
      height: auto;
      top: 60%;
      left: 50%;
      padding: .4rem 3.2rem;
      background: module.$base;
      box-shadow: 0 .24rem 2.4rem rgba(module.$base,.8);
      color: module.$white;
      border-radius: 999rem;
      transform: translate(-50%, -50%);
    }
  }
}
a{
  display: block;
  color: module.$border;
  position: relative;
  &:hover{
    figure{
      border: rgba(module.$white,.24) 1px solid;
      &:before{
        opacity: .8;
      }
      &:after{
        top: 50%;
        opacity: 1;
      }
      img{
        transform: scale(1.1);
      }
    }
  }
}
img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 320ms module.$ease;
}
dl{
  margin: 1.2rem 0 0;
  line-height: 1.6;
  position: relative;
  text-align: center;
  dt{
    font-size: .92rem;
  }
  dd{
    font-weight: 700;
  }
}
</style>

<script>
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const breakpoints = {
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    }
    const onSwiper = (swiper) => {
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      breakpoints,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    }
  },
}
</script>
